import { camelCase } from 'lodash';
export const parseStyleString = styleString => {
  const styleObject = {};
  styleString.split(';').forEach(style => {
    const _style$split = style.split(/:(?!\/)/gimu),
      key = _style$split[0],
      value = _style$split[1];
    if (key && value) {
      const camelCaseKey = camelCase(key.trim());
      // @ts-expect-error
      styleObject[camelCaseKey] = value.trim();
    }
  });
  return styleObject;
};
//# sourceMappingURL=parse-style-string.js.map